import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as _ from "lodash";
import {Application} from "../application";
import {SidebarItemType} from "../state/sidebarItemType";
import * as ko from "knockout";
import {IntercomHelper} from "../common/intercom-helper";

export class ShowIndexSearchBarCommand implements Command {
    constructor(private app: Application) {
    }

    type: CommandType = CommandType.ShowIndexSearchBar;
    canExecute = ko.computed(() => {

        let costbook = this.app.state.costbook();

        if (!costbook)
            return false;

        
        return true;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if(!this.canExecute())
            return $.Deferred().reject().promise();

        if(this.app.state.activeSidebarItem() == SidebarItemType.Index) {
            IntercomHelper.moveRight();
            this.app.state.activeSidebarItem(undefined);
        } else {
            IntercomHelper.moveLeft();
            this.app.state.activeSidebarItem(SidebarItemType.Index);
        }

        return $.Deferred().resolve().promise()
    }

    name = "Search by Index";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/showIndexSearchBarCommand.ts